var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgCheck(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 19 14' }, props),
        React.createElement("path", { d: 'M16.79 1.299a1 1 0 011.51 1.307l-.083.095-11 11.179a1 1 0 01-1.395.03l-.086-.092-5.504-6.61a1 1 0 011.45-1.371l.086.091 4.798 5.762L16.791 1.299z' })));
}
export default SvgCheck;
//# sourceMappingURL=Check.js.map